import { render } from "./RequestSummary.vue?vue&type=template&id=2d5a7ec4"
import script from "./RequestSummary.vue?vue&type=script&lang=js"
export * from "./RequestSummary.vue?vue&type=script&lang=js"

import "./RequestSummary.vue?vue&type=style&index=0&id=2d5a7ec4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__